import { Component, input } from '@angular/core';
import { Node } from '@app/models/entity.model';
import { EntitySharedModule } from '@app/modules/entity.shared.module';
import { NgxJsonViewerModule } from 'ngx-json-viewer';

@Component({
  selector: 'node-base',
  templateUrl: './base.component.html',
  styleUrls: ['./base.component.scss'],
  providers: [],
  standalone: true,
  imports: [EntitySharedModule, NgxJsonViewerModule],
})
export class BaseComponent {
  readonly entity = input.required<Node>();
}
